import { styled } from 'solid-styled-components';

export const ImagePlaceholder = styled.div`
    background-color: ${props => props.theme!.colors.background.secondary};
`;
